import { store } from '@redux/store';
import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import uiStateSlice from 'layout/redux/uiStateSlice';

document.body.addEventListener('closeAnchorClick', () => {
    const googleAnalyticsDTO = new GoogleAnalyticsEvent('Lead Events', 'Thank you page', 
    'Click on x');
    store.dispatch(uiStateSlice.actions.trackUserEvent({ googleAnalyticsDTO }));
})

document.body.addEventListener('createAccountAnchorClick', () => {
    const googleAnalyticsDTO = new GoogleAnalyticsEvent('Sign In Pop Up', 'Sign In form Open - Thank you', 
    'Sign In Clicks');
    store.dispatch(uiStateSlice.actions.trackUserEvent({ googleAnalyticsDTO }));
})